module.exports = __webpack_public_path__ + "img/homepage_about-us.9f2c9658.webp";